import { CSSProperties, HTMLProps } from 'react'
import clsx from 'classnames'
import styles from './tag-event.module.scss'

interface TagLinkProps extends HTMLProps<HTMLSpanElement> {
  color?: string
}

export const TagEvent = (props: TagLinkProps) => {
  const { className, children, color, style = {}, ...restProps } = props
  const extendStyle = color
    ? ({ '--tag-color': color.startsWith('#') ? color : `var(--${color})` } as CSSProperties)
    : {}

  return (
    <span
      className={clsx(styles.container, 'text text_type_d', className)}
      style={{ ...style, ...extendStyle }}
      {...restProps}
    >
      {children}
    </span>
  )
}
